import { Injectable, ViewContainerRef } from '@angular/core';
import * as CryptoJS from 'crypto-js'; 
import { Md5 } from 'ts-md5';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { LocalStorageService } from 'ngx-webstorage';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})

export class FunctService {
  
  public ipaddress: any;
  public appName: any;
  public secretKey: any;
  isUserLoggedIn: boolean = false;

  modalRef: BsModalRef;
  modalConfig: ModalOptions;
  ipaddressv1 : any;
  private history: string[] = [];
  constructor(
    private storage: LocalStorageService,
    private router: Router
  ) {  
      this.appName = "Shwe Tiger";

    //prod old domain cases
    // this.ipaddress = "https://apismstest.nkshops.co/api/"; 
    // this.ipaddressv1 = "https://apismstest.nkshops.co/api/v1/"; 

    //prod new domain cases
    //this.ipaddress = "https://prodapi.shwetigerapp.com/api/";
    //this.ipaddressv1 = "https://prodapi.shwetigerapp.com/api/v1/";
      
    // shewtiger domain cases
      this.ipaddress = "https://testapi.shwetiger.com/api/"; // testing en
      this.ipaddressv1 = "https://testapi.shwetiger.com/api/v1/"; // testing en
     // this.ipaddress = "https://api.shwetiger.com/api/"; // prod

      //testing 
     //this.ipaddress = "https://apitest.nkshops.co/api/"; 
     //this.ipaddressv1 = "https://apitest.nkshops.co/api/v1/";

      this.secretKey = "Yv9GlO0wX4peYxWCMGpUXM9ZKJBU78tc8cvSld5sN20";
      this.isUserLoggedIn = this.storage.retrieve('isUserLoggedIn');

      //Add tested
      this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        const url = e.urlAfterRedirects;
        const last = this.history[this.history.length - 1];
    
        if (last !== url) {
          this.history.push(url);
        }
      });    
  }

  encrypt(plainText: string): string {      
    var key = CryptoJS.enc.Utf8.parse('7061737323313233');
    var iv = CryptoJS.enc.Utf8.parse('7061737323313233');
    
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), key,
      {
        keySize: 128,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }

  getSignature(param1: string, param2: string, param3?: string): string 
  {   
    if (param1 == 'secretKey') param1 = this.secretKey;
    else if (param2 == 'secretKey') param2 = this.secretKey;
    else if (param3 == 'secretKey') param3 = this.secretKey;

    var text;
    if (param1 && param2 && param3) text = `${param1}${param2}${param3}`;
    else if (param1 && param2) text = `${param1}${param2}`;
    var sin = Md5.hashStr(text).toString();
    return sin;
  }

  // getRegisterKey() {
  //   var text = "68cf74c3da49d6d579ab81926f43a479";
  //   var sin = Md5.hashStr(text).toString();
  //   return sin;
  // }
  //Localstorage for request_id
  storeRequestIdOtp(key: string, request_id: string) 
  {
    let existing = localStorage.getItem(key);
    if (existing) {
      let updated = existing + ',' + request_id;
      localStorage.setItem(key, updated);
    } else {
      localStorage.setItem(key, request_id);
    }
  }
  getRequestIdListOld(key: string): string | string[] 
  {
    const existing = localStorage.getItem(key);
    if (!existing) {
      return [];
    }
    const values = existing.split(',');
    return values.length === 1 ? values[0] : values.join(',');
  }

  getRequestIdList(key: string): string | string[] {
    const existing = localStorage.getItem(key);
    if (!existing) {
      return [];
    }
    const values = existing
      .split(',')
      .filter(v => v && v !== 'undefined' && v !== 'null');
      console.log("Vlues ", values)
    if (values.length === 0)
    {
      return [];
    }
    return values.length === 1 ? values[0] : values.join(',');
  }
  
  getPerviousPhone() : string
  {
    return this.storage.retrieve("prevphone");
  }
  removePreviousRequestIds (key : string)
  {
    localStorage.removeItem(key);
  }
  checkingPhone(key)
  {
    const previousPhone = this.getPerviousPhone(); 
    const phoneValue = this.storage.retrieve('localPhoneValue');
    if (previousPhone && previousPhone !== phoneValue) 
    {
      this.removePreviousRequestIds(key);
    }
  }
  clearPrevPhone()
   {
    this.storage.clear("prevphone");
   }
   //app back
   back() {
    if (this.history.length <= 1) {
      return;
    }
    // remove current page
    this.history.pop();
    // get previous without removing it
    const previous = this.history[this.history.length - 1];
    this.router.navigateByUrl(previous, { replaceUrl: true });
  }  
}